import Swal from 'sweetalert2';
import React, { useCallback, useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import TennisScoreboard from "./TennisScoreboard";
import OverlayCountdown from './components/OverlayCountdown';



const Tennis = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  const [back3,setBack3]=useState([]);
  const [lay3, setLay3] = useState([]);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);
  const [active, setActive]= useState(false);
  const [side, setSide]= useState('');
    const [showOverlay, setShowOverlay] = useState(false);
    const [countdown, setCountdown] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated }= useContext(AuthContext);

  const [marketId, setMarketId] = useState(() => {
    return location.state?.marketId || sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return location.state?.runner1 || sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return location.state?.runner2 || sessionStorage.getItem("runner2") || "";
  });
  const [runner3, setRunner3] = useState(() => {
    return location.state?.runner3 || sessionStorage.getItem("runner3") || "";
  });

  const [selectedId, setSelectedId]= useState(0);
  const [runner, setRunner]= useState('');

  const competiton= sessionStorage.getItem("competitionname");
  const event= sessionStorage.getItem("eventname");
  const selectionid1= sessionStorage.getItem("selectionid1");
  const selectionid2= sessionStorage.getItem("selectionid2");
  const selectionid3= sessionStorage.getItem("selectionid3");
  const [oddsDelay, setOddsDelay] = useState();
  const [minOdds, setMinOdds]= useState(0);
  const [maxOdds, setMaxOdds]= useState(0);
  const [unmatch, setUnmatch]= useState([]);
 

  const eventId= sessionStorage.getItem("eventid");
  const [startTime, setStartTime]= useState();
  const [betData, setBetData]= useState([]);
  const [play, setPlay] = useState(false);
  const [filteredData, setFilteredData]= useState([]);
  const [avail, setAvail]= useState([]);
  const [under, setUnder]= useState(0);
  const [over, setOver]= useState(0);
  const [index, setIndex]= useState();
  const [bookDelay, setBookDelay]=useState(0);
  const [minBook, setMinBook]= useState(0);
  const [maxBook, setmaxBook]= useState(0);
  const [matchLibalities , setMatchLiblities] = useState({odds:{}, bookmaker:{}});
  const [regactive, setregactive] = useState(false);




  // bet form data
  const [formData, setFormData]= useState({
    competiton:competiton,
    eventname:event,
    eventid:0,
    marketId: marketId,
    selectionId: 0,
    runnername: '',
    betPrice:0,
    type:'odds',
    betAmount:0,
    profit:0,
    side:'',
    sportName:'tennis'
  });


  // extra market bet form
  const [formData2, setFormData2]= useState({
    competiton:competiton,
    eventname:event,
    eventid:0,
    marketId:marketId,
    selectionId:0,
    runnername:'',
    betPrice:0,
    type:'set winner',
    betAmount:0,
    profit:0,
    side:'',
    sportName:'tennis'
  });

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", { 
      year: "2-digit", 
      month: "2-digit", 
      day: "2-digit", 
      hour: "2-digit", 
      minute: "2-digit", 
      second: "2-digit",
      hour12: true 
    });
  }

  const betData1= async()=> {
      
    try{
      const response= await axios.post(base_url + '/api/webapi/betData',
        {eventId},
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
          },
        }
      );

      // console.log('databet',response);

      if(response?.data.success){
        const data= response?.data.sportsBets;
        const unmach= response?.data.unmatch;
        // console.log('ddd',data);
        setBetData(data);
        setUnmatch(unmach);
      }
    }catch(err){
      console.log(err);
    }
  }


 const handleCashOut = async (market) => {
    // console.log("cashout called");
  
    try {
      const response = await axios.get(
        `${base_url}/api/webapi/cashout/${market}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true, // Sends cookies
        }
      );
  
      // console.log("response is", response.data);
      if(response.data.success){
        handleConfirmAndSubmit(response.data.cashoutAmount , response.data.totalBetAmount ,response.data.phone , market );

      }
      
      if(!response.data.success){
        toast.error(response.data.message)
      
      }
  
    } catch (err) {
      console.error("Cashout error:", err);
      toast.error("Cashout failed. Please try again.");
    }
  };

  const handleConfirmAndSubmit = (cashout , totalbet , phone , market) => {
      
        Swal.fire({
          title: 'Are you sure?',
          text: `Available cashout amount: ${cashout} `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, declare it!',
          cancelButtonText: 'Cancel',
        }).then((result) => {
          if (result.isConfirmed) {
            submitMatchData(cashout , totalbet , phone , market); // your original function
          }
        });
    }

  const submitMatchData = async (cashout , totalbet , phone , market) =>{

        await axios.post(`${base_url}/api/webapi/giveCashOutAmount`, {
         cashout ,
         totalbet ,
         phone,
         market
        
      });
      toast.success("Cashout Successfull");
      betData1();

  }


  const getMatchLiablities = async () => {
    try {
      const response = await axios.get(`${base_url}/api/webapi/getMatchLiablity/${eventId}`, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
  
      const data = response.data;
  
      const groupedLiabilities = {
        odds: {},
        bookmaker: {},
      };
  
      data.forEach((bet) => {
        // console.log('bett',bet);
        const { type, runnerName, betAmount } = bet;
  
        // Normalize side key
        const sideKey = type.toLowerCase().replace(" ", "");
        // console.log(sideKey);
  
        if (sideKey === "odds" || sideKey === "bookmaker") {
          if (!groupedLiabilities[sideKey][runnerName]) {
            groupedLiabilities[sideKey][runnerName] = 0;
          }
  
          groupedLiabilities[sideKey][runnerName] += Number(betAmount); // Ensure betAmount is treated as number
        }
      });
  
      setMatchLiblities({odds:groupedLiabilities?.odds, bookmaker:groupedLiabilities?.bookmaker});
  
      // console.log("Odds Liabilities:", groupedLiabilities.odds);
      // console.log("Bookmaker Liabilities:", groupedLiabilities.bookmaker);
  
      // Use `groupedLiabilities.odds` and `.bookmaker` in your UI as needed
    } catch (error) {
      console.error("Error fetching match liabilities:", error);
    }
  };


  // function isTenMinutesRemaining(isoString) {
  //   const targetTime = new Date(isoString).getTime(); // Convert given time
  //   const currentTime = new Date().getTime(); // Get current time
  
  //   // Calculate the difference in milliseconds
  //   const timeDifference = targetTime - currentTime;
  
  //   // Convert milliseconds to minutes
  //   const minutesRemaining = timeDifference / (1000 * 60);
  
  //   return minutesRemaining > 10;
  // }

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };


  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  useEffect(() => {
    const getTimeDelay = async () => {

      try {
        const response = await axios.get(base_url + '/get/api/webapi/sportsData/timeDelay',
          {
            withCredentials: true,
            headers: {
              'content-type': 'application/json'
            }
          }
        );
        if (response?.data.success) {
          if (response?.data.betDelay.length > 0) {
            let timeDelayData = response?.data.betDelay;
            const delays = timeDelayData[0] || '';

            const oddss = JSON.parse(delays?.match_odds_tennis);
            const oddsDelay = oddss?.bet_delay || 0;
            const minBet= oddss?.min_bet || 0;
            const maxBet= oddss?.max_bet || 0;
            // console.log(minBet);
            setMinOdds(minBet);
            setMaxOdds(maxBet);
            setOddsDelay(oddsDelay * 1000);

            const bookmaker = JSON.parse(delays?.book_maker_tennis);
            const bookDelay = bookmaker?.bet_delay || 0;
            const minBook= oddss?.min_bet || 0;
            const maxBook= oddss?.max_bet || 0;
            // console.log(minBet);
            setMinBook(minBook);
            setmaxBook(maxBook);
            setBookDelay(bookDelay * 1000);

          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    getTimeDelay();
  }, []);


  


  // formdata odds
  const handleSubmit = async () => {

    if(!isAuthenticated){
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(startTime)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < minOdds) {
      toast.error("Bet can't be placed less than minimum Value");
      return;
    }

    if (money > maxOdds) {
      toast.error("Bet can't be placed greater than maximum  Value");
      return;
    }


    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // console.log('form',formData);
    const delay=oddsDelay || 0;

    if (delay > 0) {
        let remaining = Math.ceil(delay / 1000);
        setCountdown(remaining);
        setShowOverlay(true);

        const intervalId = setInterval(() => {
          remaining -= 1;
          setCountdown(remaining);
          if (remaining <= 0) {
            clearInterval(intervalId);
            setShowOverlay(false);
          }
        }, 1000);
    }

   setTimeout(async()=>{
    if(side==='Back'){
      const allBackPrices = [...back1, ...back2];

      const valuee= allBackPrices.some((bac)=> bac.price===selectedPrice);

      if (!valuee) {
          
        try{
          const response= await axios.post(base_url + '/api/webapi/unmatched',
            formData,
            {
              withCredentials:true,
              headers:{
                'content-type':'application/json',
              }
            }
          );

          if(response?.data.success){
            toast.error("Bet placed to unmatched due to value change");
            betData1();
          }

          setbackActive(0);
    setlayActive(3);
    setOver(0);
    setUnder(0);
        }catch(err){
          console.log(err);
        }

        return;
      }
    
    };

    if(side==='Lay'){
      const allLayPRices= [...lay1, ...lay2];
      const values= allLayPRices.some((lay)=> lay.price===selectedPrice);

      if (!values) {
          
        try{
          const response= await axios.post(base_url + '/api/webapi/unmatched',
            formData,
            {
              withCredentials:true,
              headers:{
                'content-type':'application/json',
              }
            }
          );

          if(response?.data.success){
            toast.error("Bet placed to unmatched due to value change");
            betData1();
          }
          setbackActive(0);
    setlayActive(3);
    setOver(0);
    setUnder(0);

        }catch(err){
          console.log(err);
        }

        return;
      }
    };
    

   try{
    const response= await axios.post(base_url + '/api/webapi/sportsData',
      formData,
      {
        withCredentials:true,
        headers:{
          'content-type':'application/json',
        }
      }
    );

    // console.log('formmatch',response);

    if(response?.data.success){
      toast.success(response?.data.message);
      betData1();
    }else{
      toast.error(response?.data.message);
    }
   
    setbackActive(0);
    setlayActive(3);
    setOver(0);
    setUnder(0);
   }catch(err){
    console.log(err);
    toast.error("Failed to place bet");
   }
   },delay)

    
  };

  // formdata2 tennis extra data bets
  const handleSubmit2 = async () => {

    if(!isAuthenticated){
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(startTime)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < minBook) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (money > maxBook) {
      toast.error("Bet cant be placed less than min value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // console.log('form',formData2);

    const delay= bookDelay || 0;
     
    if (delay > 0) {
    let remaining = Math.ceil(delay / 1000);
    setCountdown(remaining);
    setShowOverlay(true);

    const intervalId = setInterval(() => {
      remaining -= 1;
      setCountdown(remaining);
      if (remaining <= 0) {
        clearInterval(intervalId);
        setShowOverlay(false);
      }
    }, 1000);



    }


   setTimeout(async()=> {
    try{
      const response= await axios.post(base_url + '/api/webapi/sportsData',
        formData2,
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
          }
        }
      );
  
      // console.log('formmatch',response);
  
      if(response?.data.success){
        toast.success(response?.data.message);
        betData1();
      }else{
        toast.error(response?.data.message);
      }
      
      setbackActive(0);
    setlayActive(3);
    setOver(0);
    setUnder(0);
  
     }catch(err){
      console.log(err);
      toast.error("Failed to place bet");
     }
   },delay);

    
  };




  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setMarketId(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner1(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setRunner2(location.state.runner2);
    }

    if (location.state?.runner3) {
      sessionStorage.setItem("runner3", location.state.runner3);
      setRunner3(location.state.runner3);
    }


    const proft = (parseFloat(selectedPrice) * parseFloat(money)) - parseFloat(money);
    setProfit(proft.toFixed(1));


    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);



  useEffect(() => {
    window.scrollTo(0, 0);

    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('reees',response);
        const status1= response?.data.result[0]?.status;
        const status2= response?.data.result[1]?.status;
        const status3= response?.data.result[2]?.status;
        // console.log(status1);
        // console.log(status2);

        if(status1==='ACTIVE'){
          
  
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);

        }



        if(status2==='ACTIVE'){

        const backk2 = response?.data.result[1]?.ex?.availableToBack;
        const layy2 = response?.data.result[1]?.ex?.availableToLay;

        setBack2(backk2);
        setLay2(layy2);

        }
        if(status3==='ACTIVE'){

        const backk3 = response?.data.result[2]?.ex?.availableToBack;
        const layy3 = response?.data.result[2]?.ex?.availableToLay;

        setBack3(backk3);
        setLay3(layy3);

        }


      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const TennisData = async () => {
        
      try {
        const response = await axios.get(
          base_url + `/api/webapi/tennisapi/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        
        const data= response?.data;
        // console.log('tennis extra deepanshu',data);

        if (data?.marketdata?.length > 0) {
          const marketdata = data.marketdata[0];
        // console.log('fillterrr',marketdata);
          const filteredMarkets = marketdata.markets.filter(market => market.marketName !== 'Match Odds');

          
          setFilteredData(filteredMarkets);
          // console.log("Filtered Markets:", filteredMarkets);
        } else {
          console.log("No market data found.");
        }
        
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    
    const sessiontime= sessionStorage.getItem('time');
    const time= formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData= ()=> {
      getMatchLiablities();
      backLay();
      TennisData();
      
    };

    betData1();
    

    const intervalId = setInterval(updateData, 1000);

  // Cleanup function to clear interval on component unmount
  return () => clearInterval(intervalId);
  }, []);


  const footballMarket= async(req,res)=>{
    try{
      // console.log('filll tennis',filteredData);
      const marketIds = filteredData.map(market => market.marketId);
      // console.log('tennis',marketIds);

      const response = await axios.post(
        base_url + `/api/webapi/footballapi/wholemarket`,
        marketIds,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    // console.log('tennis over under deepanshu data is',response);
    const resss=response?.data;

    setAvail(resss);

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
      if (filteredData.length > 0) {
        const intervalId = setInterval(() => {
          footballMarket(); // calls every second
        }, 1000);
    
        return () => clearInterval(intervalId); // cleanup on unmount
      }
    }, [filteredData]);

// console.log('matchess',wpMarket);


  // betformdata
  formData.selectionId= selectedId;
  formData.runnername=runner;
  formData.betAmount=money;
  formData.profit= profit;
  formData.eventid=eventId;
  formData.betPrice=selectedPrice;
  formData.side=side;


  // formdata2
  formData2.eventid=eventId;
  formData2.runnername=runner;
  formData2.betAmount=money;
  formData2.profit=profit;
  formData2.betPrice=selectedPrice;
  formData2.selectionId= selectedId;
  formData2.side=side;


  

  return (
    <>
    {<LoginReg active={active} setactive={setActive} setregactive={setregactive} regactive={regactive} />}
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="" className="rightbar">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />

              <div
                _ngcontent-jrx-c95=""
                className="rightbar d-flex flex-column"
                style={{
                  width: isSidebar ? "" : "2500%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />
                <OverlayCountdown show={showOverlay} countdown={countdown} />
                

                <div className="mt-3 d-flex flex-column flex-lg-row justify-content-between mainn w-100 px-3">
                  <div className="match-content">

                    <p className="breadcrumb">
                      Home &gt; Tennis &gt; {competiton} &gt;
                      {event} &gt; Match Odds
                    </p>

                    <div className="d-flex gap-5 align-items-center">
                    <span className="text-info fs-5 inline">Start Time: &nbsp;{startTime}</span>
                    {/* <span>Time Remaining: </span> */}
                    </div>

                    <div className="position-relative pl-1 showinphone ">
                        {" "}
                        {/* Added position relative */}
                        <div
                          className=" p-2 cursor-pointer d-flex justify-content-between"
                          style={{ background: "rgb(223 223 223)" }}
                          onClick={() => setPlay(!play)}
                        >
                          <div>
                            <span>
                              {" "}
                              <i
                                className="bi bi-broadcast fs-16"
                                style={{ color: "#DC3545" }}
                              ></i>
                            </span>
                            <span> Watch Live Match</span>
                          </div>
                          <div>
                            <button
                              className="live-stream-button ng-star-inserted"
                              style={{
                                backgroundColor: "#fd2954",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                              }}
                            >
                              {" "}
                              Watch Live{" "}
                            </button>
                          </div>
                        </div>
                        {play && (
                          <iframe
                            title="Live TV"
                            className="border w-100 h-100"
                            src={`https://dpmatka.in/dtv.php?id=${eventId}`}
                            allowFullScreen
                            referrerPolicy="strict-origin-when-cross-origin"
                            sandbox="allow-same-origin allow-scripts"
                          ></iframe>
                        )}
                      </div>

                   <TennisScoreboard />

                    <div className="match-section">
                      <div className="match-header d-flex align-items-baseline gap-2 mt-4">
                        <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-center">
                          <p className="bg-yellow text-black pt-2 pb-3 me-3 px-4 rad bett">
                            Match Odds
                          </p>
                          <p className="d-flex gap-1 fszz">
                            <span>
                              Min:{minOdds}<span>|</span>{" "}
                            </span>{" "}
                            Max:{maxOdds}
                          </p>
                        </div>

                        <p   onClick={() => {
                        // console.log("Clicked. marketId:", marketId);
                        handleCashOut(marketId);
                      }} className="btn btn-success rounded-pill text-black">
                          Cashout
                        </p>

                        <div
                          className="d-flex align-items-center gap-4 ms-0 ms-md-auto me-4 mt-2 mt-md-0"
                          style={{ height: "5rem"}}
                        >
                          <p className="text-info fs-5">Back</p>
                          <p className="text-green fs-5">Lay</p>
                        </div>
                      </div>

                      <div className="betting-options d-flex flex-column p-2 gap-2">
                        <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-yellow p-1">
                          <h5 className="fs-4 text-wrap run" id={selectionid1}>{runner1}<br/> <span className='text-green pl-2' style={{fontSize:'12px'}}>{matchLibalities?.odds?.[runner1] || ''}</span></h5>
                          

                          <div className="d-flex gap-2">
                          <span
                              className={`${
                                pr === 1
                                  ? "d-block text-green"
                                  : pr === 2
                                  ? "d-block text-green"
                                  : (pr===3 || pr===4  || pr===17 || pr===18)?
                                    'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===3 || pr===4 || pr===17 || pr===18 ? -money : profit}
                            </span>
                            

                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-75 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc?.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-75 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc?.price}
                              </div>
                            ))}
                          </div>
                        </div>

                        

                        <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-yellow p-1">
                          <h5 className="fs-4 text-wrap run" id={selectionid2}>{runner2} <br/> <span className='text-green pl-2' style={{fontSize:'12px'}}>{matchLibalities?.odds?.[runner2] || ''}</span></h5>
                          
                          <div className="d-flex  gap-2">
                          <span
                              className={`${
                                pr === 3
                                  ? "d-block text-green"
                                  : pr === 4
                                  ? "d-block text-green"
                                  : (pr===1 || pr===2 || pr===17 ||pr===18)
                                  ? 'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===1 || pr===2 || pr===17 || pr===18 ? -money : profit }
                            </span>
                       
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSide('Back');
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc?.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSide('Lay');
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc?.price}
                              </div>
                            ))}
                          </div>
                        </div>
                      
                      </div>

                          {/* betting back div */}
                      {backActive !== 0 && (
                        <div className="d-flex flex-column justify-content-end border border-3 border-warning rounded p-2 gap-4 bck">
                          <div className="d-flex justify-content-end gap-1">
                            <span className="fs-3 mr-4">
                              {backActive === 1 ? runner1 : runner2}
                            </span>

                            <div className="active gap-2 border h-100">
                            <div className="d-flex justify-content-end wd border h-100">
                              <button
                                className="bg-secondary border rounded-left h-100"
                                onClick={() => handlelayChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) =>
                                  setSelectedPrice(e.target.value)
                                }
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border h-100"
                                onClick={() => handlelayChange(1)}
                              >
                                +
                              </button>
                            </div>

                            <div className="d-flex justify-content-end wd border h-100">
                              <button
                                className="bg-secondary border rounded-left h-100"
                                onClick={() => handleChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border border h-100"
                                onClick={() => handleChange(1)}
                              >
                                +
                              </button>
                            </div>
                            </div>
                            
                          </div>

                          <div className="d-flex flex-wrap justify-content-end gap-2">
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(100)}
                            >
                              100
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(500)}
                            >
                              500
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(1000)}
                            >
                              1000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(5000)}
                            >
                              5000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(10000)}
                            >
                              10000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(50000)}
                            >
                              50000
                            </div>
                            <div
                              className="bg-green rounder border rounded px-3 py-2 text-white fw-bold cursor-pointer fs-5"
                              onClick={() => handleSubmit()}
                            >
                              Place Bet
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 py-2 cursor-pointer fs-5"
                              onClick={() => {
                                setbackActive(0);
                                setMoney(0);
                                setPr(0);
                              }}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      )}

                      {/* betting lay div */}
                      {layActive !== 3 && (
                        <div className="d-flex flex-column justify-content-end border border-3 border-warning rounded p-2 gap-4 lay">
                          <div className="d-flex justify-content-end gap-1">
                            <span className="fs-3 mr-4">
                              {layActive === 4 ? runner1 : runner2}
                            </span>
                            
                            <div className="active gap-2">
                            <div className="d-flex justify-content-end wd border h-75">
                              <button
                                className="bg-secondary border rounded-left border h-100"
                                onClick={() => handlelayChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) =>
                                  setSelectedPrice(e.target.value)
                                }
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border h-100"
                                onClick={() => handlelayChange(1)}
                              >
                                +
                              </button>
                            </div>

                            <div className="d-flex justify-content-end wd border h-75">
                              <button
                                className="bg-secondary border rounded-left border h-100"
                                onClick={() => handleChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                name="mon"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border h-100"
                                onClick={() => handleChange(1)}
                              >
                                +
                              </button>
                            </div>
                            </div>
                          </div>

                          <div className="d-flex flex-wrap justify-content-end gap-2">
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(100)}
                            >
                              100
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(500)}
                            >
                              500
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(1000)}
                            >
                              1000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(5000)}
                            >
                              5000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(10000)}
                            >
                              10000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(50000)}
                            >
                              50000
                            </div>
                            <div className="bg-green rounder border rounded px-3 py-2 text-white fw-bold cursor-pointer fs-5" onClick={handleSubmit}>
                              Place Bet
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 py-2 cursor-pointer fs-5"
                              onClick={() => {
                                setlayActive(3);
                                setMoney(0);
                                setPr(0);
                              }}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      )}
                    

                    {/* over under markets */}
                    {filteredData.length>0 && filteredData.map((filterr, indx)=>{
                        const marketData = Array.isArray(avail) ? avail.find(market => market.marketId === filterr.marketId) : null;
                        // console.log('markett',marketData);
                        const goalLineMatch = filterr.marketName?.match(/(\d+(\.\d+)?)/); // matches numbers like 0.5, 1.5
                        const goalLine = goalLineMatch ? goalLineMatch[0] : '';
                    
                        // Assign team labels
                        const team1 = `Under ${goalLine}`;
                        const team2 = `Over ${goalLine}`;

                        if(!marketData) return null;


                        const runn1= marketData?.runners[0];
                        const runn2= marketData?.runners[1];

                        // console.log('runn1',runn1);
                        // console.log('runn2',runn2);



                        return(
                        <>
                        
                        <div className="match-header d-flex align-items-center gap-2 mt-4">
                        <div className="d-flex flex-lg-row flex-column  flex-md-row align-items-center">
                          <p className="bg-yellow text-black pt-2 pb-3 me-3 px-4 rad bett">
                            {filterr.marketName}
                          </p>
                          <p className="d-flex gap-1 fszz">
                            <span>
                              Min:{minBook} <span>|</span>{" "}
                            </span>{" "}
                            Max:{maxBook}
                          </p>
                        </div>

                        <p   onClick={() => {
                        console.log("Clicked. marketId:", marketId);
                        handleCashOut(marketId);
                      }} className="btn btn-success rounded-pill text-black">
                          Cashout
                        </p>
                      </div>


                      <div className="betting-options d-flex flex-column p-2 gap-2">
                        
                        <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-2 bg-yellow p-3">
                          <h5 className="fs-4 text-wrap run" id={runn1.selectionId}>{team1}</h5>
                          

                          <div className="d-flex gap-2">
                          <span
                              className={`${
                                pr === 5
                                  ? "d-block text-green"
                                  : pr === 6
                                  ? "d-block text-green"
                                  : (pr===7 || pr===8 )?
                                    'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===7 || pr===8 ? -money : profit}
                            </span>
                            

                            {Array.isArray(runn1?.ex?.availableToBack) && runn1?.ex?.availableToBack.length>0 && runn1?.ex?.availableToBack.reverse().map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(0);
                                  setlayActive(3);
                                  setUnder(1);
                                  setOver(0);
                                  setSelectedPrice(bc.price);
                                  setPr(5);
                                  setSelectedId(runn1.selectionId);
                                  setRunner(team1);
                                  setSide('Back');
                        
                                  setIndex(indx);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {Array.isArray(runn1?.ex?.availableToLay) && runn1?.ex?.availableToLay.length>0 && runn1?.ex?.availableToLay.map((bc, index) => (
                              <div
                                className={`rounded p-2 fs-5 h-75 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(3);
                                  setbackActive(0);
                                  setUnder(0);
                                  setOver(1);
                                  setSelectedPrice(bc.price);
                                  setPr(6);
                                  setSelectedId(runn1.selectionId);
                                  setRunner(team1);
                                  setSide('Lay');
                        
                                  setIndex(indx);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                          </div>
                        </div>

                        

                        <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-2 bg-yellow p-1">
                          <h5 className="fs-4 text-wrap run" id={runn2.selectionId}>{team2}</h5>
                          
                          <div className="d-flex  gap-2">
                          <span
                              className={`${
                                pr === 7
                                  ? "d-block text-green"
                                  : pr === 8
                                  ? "d-block text-green"
                                  : (pr===5 || pr===6)
                                  ? 'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===5 || pr===6 ? -money : profit }
                            </span>
                       
                            {Array.isArray(runn2?.ex?.availableToBack) && runn2?.ex?.availableToBack.length>0 && runn2?.ex?.availableToBack.reverse().map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-100 text-center cursor-pointer ${
                                  index < back2.length - 1
                                    ? "bg-secondary dnone"
                                    : "bg-info"
                                }`}
                                onClick={() => {
                                  setbackActive(0);
                                  setlayActive(3);
                                  setUnder(1);
                                  setOver(0);
                                  setSelectedPrice(bc.price);
                                  setPr(7);
                                  setSelectedId(runn2.selectionId);
                                  setRunner(team2);
                                  setSide('Back');
                                  setIndex(indx);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {Array.isArray(runn2?.ex?.availableToLay) && runn2?.ex?.availableToLay.length>0 && runn2?.ex?.availableToLay.map((bc, index) => (
                              <div
                                className={`rounded p-1 mt-1 fs-16 h-100 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(3);
                                  setbackActive(0);
                                  setOver(1);
                                  setUnder(0);
                                  setSelectedPrice(bc.price);
                                  setPr(8);
                                  setSelectedId(runn2.selectionId);
                                  setRunner(team2);
                                  setSide('Lay');
                                  setIndex(indx);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                          </div>
                        </div>

                        
                      </div>

                      {/* betting back div */}
                      {under !== 0 && index===indx && (
                        <div className="d-flex flex-column justify-content-end border border-3 border-warning rounded p-2 gap-4 bck">
                          <div className="d-flex justify-content-end gap-1">
                            <span className="fs-3 mr-4">
                              {runner}
                            </span>

                            <div className="active gap-2 border h-100">
                            <div className="d-flex justify-content-end wd border h-100">
                              <button
                                className="bg-secondary border rounded-left h-100"
                                onClick={() => handlelayChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) =>
                                  setSelectedPrice(e.target.value)
                                }
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border h-100"
                                onClick={() => handlelayChange(1)}
                              >
                                +
                              </button>
                            </div>

                            <div className="d-flex justify-content-end wd border h-100">
                              <button
                                className="bg-secondary border rounded-left h-100"
                                onClick={() => handleChange(0)}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="bg-white border-0 w-100 text-center fs-5 border h-100"
                              />
                              <button
                                className="bg-secondary border rounded-right border border h-100"
                                onClick={() => handleChange(1)}
                              >
                                +
                              </button>
                            </div>
                            </div>
                            
                          </div>

                          <div className="d-flex flex-wrap justify-content-end gap-2">
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(100)}
                            >
                              100
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(500)}
                            >
                              500
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(1000)}
                            >
                              1000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(5000)}
                            >
                              5000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(10000)}
                            >
                              10000
                            </div>
                            <div
                              className="bg-info rounder border rounded px-3 pt-1 text-black text-center fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(50000)}
                            >
                              50000
                            </div>
                            <div
                              className="bg-green rounder border rounded px-3 py-2 text-white fw-bold cursor-pointer fs-5"
                              onClick={() => handleSubmit2()}
                            >
                              Place Bet
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 py-2 cursor-pointer fs-5"
                              onClick={() => {
                                setUnder(0);
                                setMoney(0);
                                setPr(0);
                              }}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      )}

                      {/* betting lay div */}
                      {over !== 0 && index===indx && (
                        <div className="d-flex flex-column justify-content-end border border-3 border-warning rounded p-2 gap-4 lay">
                          <div className="d-flex justify-content-end gap-1">
                            <span className="fs-3 mr-4">
                              {runner}
                            </span>
                            
                            <div className="active gap-2">
                              <div className="d-flex justify-content-end wd border h-75">
                                <button
                                  className="bg-secondary border rounded-left border h-100"
                                  onClick={() => handlelayChange(0)}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  value={selectedPrice}
                                  onChange={(e) =>
                                    setSelectedPrice(e.target.value)
                                  }
                                  className="bg-white border-0 w-100 text-center fs-5 border h-100"
                                />
                                <button
                                  className="bg-secondary border rounded-right border h-100"
                                  onClick={() => handlelayChange(1)}
                                >
                                  +
                                </button>
                              </div>

                              <div className="d-flex justify-content-end wd border h-75">
                                <button
                                  className="bg-secondary border rounded-left border h-100"
                                  onClick={() => handleChange(0)}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  name="mon"
                                  value={money}
                                  onChange={(e) => setMoney(e.target.value)}
                                  className="bg-white border-0 w-100 text-center fs-5 border h-100"
                                />
                                <button
                                  className="bg-secondary border rounded-right border h-100"
                                  onClick={() => handleChange(1)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="d-flex flex-wrap justify-content-end gap-2">
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(100)}
                            >
                              100
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(500)}
                            >
                              500
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(1000)}
                            >
                              1000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(5000)}
                            >
                              5000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(10000)}
                            >
                              10000
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 pt-1 text-center text-black fw-bold cursor-pointer fs-5"
                              onClick={() => setMoney(50000)}
                            >
                              50000
                            </div>
                            <div className="bg-green rounder border rounded px-3 py-2 text-white fw-bold cursor-pointer fs-5" onClick={()=>handleSubmit2()}>
                              Place Bet
                            </div>
                            <div
                              className="bg-pink rounder border rounded px-3 py-2 cursor-pointer fs-5"
                              onClick={() => {
                                setOver(0);
                                setMoney(0);
                                setPr(0);
                              }}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      )}
                        </>
                        )
                      })}
                    </div>
                  </div>

                  <div  className="bets-container d-flex flex-column betTv  gap-5 ">
                  <div className="d-none d-lg-block position-relative pl-1 "> {/* Added position relative */}
                  
                  <div className=" p-2 cursor-pointer d-flex justify-content-between"  style={{background:"rgb(223 223 223)"}} onClick={()=> setPlay(!play)}>
                
                 <div>
                 <span> <i className="bi bi-broadcast fs-16"  style={{color:"#DC3545"}}></i></span>
                 <span> Watch Live Match</span>
                 </div>
                 <div>
                 <button className="live-stream-button ng-star-inserted" style={{backgroundColor : "#fd2954" , color : "white" , border:"none" , borderRadius:"6px"}} > Watch Live </button>
                 </div>
                  
                   </div>
                  
             
  
                {play && (
                  <iframe
                  title="Live TV"
                  className="border w-100 h-100"
                  src={`https://dpmatka.in/dtv.php?id=${eventId}`}
                  allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                                          sandbox="allow-same-origin allow-scripts"
                  ></iframe>
                  )}

               </div>
               
                  <div className="rounded-4 mt-3 mt-lg-0 ms-0 ms-lg-3 mb-4  h-100" 
                  style={{ maxHeight: "100vh", height: `${betData?.length*6}vh`}}
                  >
                    <p className="bg-yellow m-0 rounded-top-4 p-2 bett">
                      My Bets
                    </p>
                    <table
                          className=" border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: "white",
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1 text-black"
                            >
                              Unmatched bets
                            </div>
                            <tr>
                              <th>Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {unmatch?.length > 0 ? (
                              unmatch?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td>{bet.betprice}</td>
                                  <td>{bet.betAmount}</td>
                                  <td>{bet.profit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>

                    <table
                      className="table table-dark border  w-100"
                      style={{ borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr>
                          <th>Runner Name</th>
                          <th>ODDS</th>
                          <th>Bet Amount</th>
                          <th>P/L</th>
                        </tr>
                      </thead>

                      <tbody>
                        {betData?.length > 0 ? (
                          betData?.map((bet, index)=> (
                            <tr key={index}>
                              <td>{bet.runnerName}&nbsp;({bet.type})</td>
                              <td>{bet.betprice}</td>
                              <td>{bet.betAmount}</td>
                              <td>{bet.profit}</td>
                            </tr>
                          ))
                        ): 
                          <tr>
                            {/* <td className=" text-white bett" onClick={()=> setActive(true)}>Login required</td>
                            <td className=" text-white bett">to view</td>
                            <td className=" text-white bett">bet data</td> */}
                            <td>No bet data</td>
                          </tr>
                          }

                      </tbody>
                    </table>
                  </div>
               </div>


                </div>
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
    </>
  );
};

export default Tennis;